<script>
  import { fly } from "svelte/transition";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  let routerID;
  if (sessions.routeractive) {
    routerID = sessions.routeractive.id;
  } else {
    routerID = 1;
  }
</script>

<div
  transition:fly={{ x: -200, duration: 1000 }}
  class="fixed bottom-0 left-0 right-0 top-auto w-full bg-gray-100 bg-opacity-100 border-t shadow-xl lg:bg-opacity-75 md:bg-opacity-100 lg:right-auto md:right-0 lg:top-0 md:top-auto lg:bottom-auto md:bottom-0 lg:h-screen md:h-12 h12 lg:w-20 md:w-screen lg:border-none md:border-none"
>
  <div
    class="flex flex-no-wrap justify-start w-full h-12 px-0 pt-0 overflow-x-auto text-center text-gray-700 lg:justify-center md:justify-start justify-self-auto lg:flex-wrap md:flex lg:h-full md:h-12 lg:pt-24 md:pt-0 lg:overflow-x-hidden md:overflow-x-auto"
  >
    <a
      class="flex-wrap items-center w-3/12 py-1 text-center transition duration-300 ease-in-out bg-transparent border-r lg:block md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:bg-gray-300 delay-50"
      href="/{routerID}/hotspot-profile"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Profile</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-user"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">User</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-active"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Active</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-host"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Host</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-cookie"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Cookie</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-binding"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Binding</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-user-print"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Voucher</small>
        </div>
      </div>
    </a>
    <a
      class="items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/{routerID}/hotspot-generate"
    >
      <div class="w-16 lg:w-full md:w-full">
        <svg
          class="w-6 h-6 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
          />
        </svg>
        <div class="relative w-auto overflow-hidden truncate">
          <small class="text-xs">Generate</small>
        </div>
      </div>
    </a>
    <a
      class="flex items-center w-3/12 py-1 text-center transition duration-300 ease-in-out delay-75 bg-gray-200 bg-opacity-0 border-b border-r lg:flex-wrap lg:hidden md:flex lg:border-b md:border-r lg:w-full md:w-3/12 lg:py-2 md:py-1 hover:shadow hover:font-bold hover:bg-opacity-100"
      href="/chat"
    >
      <div class="w-16 lg:w-full md:w-full" />
    </a>
  </div>
</div>
